'use client';

import {MeinDivider} from '@components/@shared';
import {MeinText} from '@components/@typography/MeinText';
import {tid} from '@utils/tid';
import classNames from 'classnames';
import {FC, ReactElement, useState} from 'react';
import styles from './MeinTabs.module.css';

export interface ITab {
    tabLabel: string;
    tabContent?: ReactElement;
    tabLabelTag?: ReactElement | string;
    disabled?: boolean;
    handleClick?: () => void;
}

interface IProps {
    tabs: ITab[];
    initialActiveTab?: number;
    classNameTabHeaderContainer?: string;
    classNameTabHeadline?: string;
    classNameTabHeadlineButton?: string;
    classNameTabContent?: string;
    classNameActiveTab?: string;
    classNameDivider?: string;
    hideContent?: boolean;
}

export const MeinTabs: FC<IProps> = ({
    tabs,
    initialActiveTab = 0,
    classNameTabHeaderContainer,
    classNameTabHeadline,
    classNameTabHeadlineButton,
    classNameTabContent,
    classNameActiveTab,
    classNameDivider,
    hideContent,
}) => {
    const [activeTabIndex, setActiveTabIndex] = useState(initialActiveTab);

    const TabContentComponent = tabs?.[activeTabIndex]?.tabContent;

    return (
        <div>
            <div
                className={classNames(
                    styles.tabHeader,
                    classNameTabHeaderContainer,
                    {[styles.centeredTab]: tabs.length === 1},
                )}
            >
                {tabs.map(
                    ({tabLabel, tabLabelTag, disabled, handleClick}, index) => {
                        return (
                            <button
                                name={tabLabel}
                                disabled={disabled}
                                key={'tab-headline' + tabLabel}
                                className={classNames(
                                    styles.tabHeadlineButton,
                                    classNameTabHeadlineButton,
                                )}
                                onClick={() => {
                                    handleClick?.();
                                    setActiveTabIndex(index);
                                }}
                                {...tid('search-tab-' + tabLabel)}
                            >
                                <MeinText
                                    tag="span"
                                    type="label"
                                    size="l"
                                    className={classNames(
                                        styles.tabHeadlineText,
                                        classNameTabHeadline,
                                        index === activeTabIndex &&
                                            classNameActiveTab,

                                        {
                                            [styles.activeTabBorder]:
                                                tabs.length > 1 &&
                                                index === activeTabIndex,
                                        },
                                    )}
                                >
                                    {tabLabel}
                                    {tabLabelTag}
                                </MeinText>
                            </button>
                        );
                    },
                )}
            </div>
            <MeinDivider className={classNameDivider} />
            {!hideContent && (
                <div className={classNameTabContent}>{TabContentComponent}</div>
            )}
        </div>
    );
};
